import type { MapMarkerStyle } from '@gpx-spa/geo-domain';
import { exceptionIconDisplayForSeverity } from '@/utils/shipment-exception-display';

const ICON_SIZE_PX = 24;
const FALLBACK_FILL_HEX = '#525252';

function safeFillHex(color: string): string {
  const c = color.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(c)) return c;
  return FALLBACK_FILL_HEX;
}

/** Material-style warning triangle (same silhouette as PrimeIcons exclamation-triangle). */
function exceptionTriangleIconDataUrl(fillHex: string): string {
  const fill = safeFillHex(fillHex);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${ICON_SIZE_PX}" height="${ICON_SIZE_PX}"><path fill="${fill}" stroke="#ffffff" stroke-width="1.25" stroke-linejoin="round" fill-rule="evenodd" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

/** Map pin style for an exception severity. New types do not change this. */
export function exceptionMapMarkerStyle(severity: string): MapMarkerStyle {
  const fill =
    exceptionIconDisplayForSeverity(severity)?.mapFillHex ?? FALLBACK_FILL_HEX;
  return {
    kind: 'icon',
    icon: {
      url: exceptionTriangleIconDataUrl(fill),
      size: [ICON_SIZE_PX, ICON_SIZE_PX],
      anchor: [ICON_SIZE_PX / 2, ICON_SIZE_PX / 2],
      popupAnchor: [0, -ICON_SIZE_PX / 2],
    },
  };
}
